import { render, staticRenderFns } from "./Numboard.vue?vue&type=template&id=71fde1ae"
import script from "./Numboard.vue?vue&type=script&lang=js"
export * from "./Numboard.vue?vue&type=script&lang=js"
import style0 from "./Numboard.vue?vue&type=style&index=0&id=71fde1ae&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports